import React, { useEffect, useState ,useContext} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome, faBagShopping, faBank, faCartShopping, faBasketShopping,
  faUserPlus, faRectangleList, faFolder,
  faPlusCircle,
  faCaretLeft,
  faCaretRight,
  faCaretDown,
  faDashboard,
  faGear,
  faExclamationTriangle,
  faX,
  faShoppingBasket,
  faBullseye,
  faShopSlash,
  faZap,
  faGift,
  faCoins,
  faTag,
  faPercent,
  faTags,
  faFileLines,
  faTruck
} from '@fortawesome/free-solid-svg-icons';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';
import { useLocation,useNavigate } from 'react-router-dom';
import { Loader ,Spinner } from '../Loader/Loader';
import { decryptData } from '../../utils/storageCrypto';


function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => setMatches(media.matches);
    window.addEventListener("resize", listener);
    return () => window.removeEventListener("resize", listener);
  }, [matches, query]);

  return matches;
}

const Sidebar = () => {

  const isMobile = useMediaQuery('(max-width: 768px)');
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [Items, setItems] = useState(false);
  const [Sales, setSales] = useState(false);
  const [Purchases, setPurchases] = useState(false);
  const [Reports, setReports] = useState(false);
  const [Settings, setSettings] = useState(false);
  const [QuickBuy, setQuickBuy] = useState(false);
  const [Buildcoins, setBuildcoins] = useState(false);
  const [Discounts, setDiscounts] = useState(false);
  const location = useLocation();
  const [isSaving, setIsSaving] = useState(false);
  const navigate = useNavigate();
  const encryptedroleId = parseInt(sessionStorage.getItem('roleId'), 10);
  const roleId = decryptData(encryptedroleId);
  const [liveTicketsCount, setLiveTicketsCount] = useState(0);

  useEffect(() => {
    setIsCollapsed(isMobile);
  }, [isMobile]);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  
  
  useEffect(() => {
  let isMounted = true;

  const fetchLiveTicketsCount = async () => {
    try {
      // Replace this URL with your actual Tickets GET API endpoint.
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}returns/get-tickets`);

      if (!response.ok) {
        throw new Error('Failed to fetch tickets');
      }

      const result = await response.json();

      const tickets = Array.isArray(result)
        ? result
        : result.tickets ||
          result.data?.tickets ||
          result.data ||
          [];

      const activeCount = tickets.filter((item) => {
        const status = String(item.status || 'OPEN')
          .trim()
          .toUpperCase();

        return !['RESOLVED', 'CLOSED', 'REJECTED'].includes(status);
      }).length;

      console.log("activeCount:",activeCount);

      if (isMounted) {
        setLiveTicketsCount(activeCount);
      }
    } catch (error) {
      console.error('Error fetching live tickets count:', error);
    }
  };

  fetchLiveTicketsCount();

  const intervalId = setInterval(fetchLiveTicketsCount, 30000);

  return () => {
    isMounted = false;
    clearInterval(intervalId);
  };
}, []);


  const shouldShowMenuItem = (menuItem) => {
    switch (roleId) {
      case 0:
        return true; // All menu items visible
      case 1:
        return menuItem !== 'Reports' && menuItem !== 'Settings'; // All except
      case 2:
      case 3:
        return menuItem === 'Home' || menuItem === 'Projects';
      case 4:
        return menuItem === 'Items' || menuItem === 'Sales';
      case 6:
        return menuItem !== 'Reports' && menuItem !== 'Settings' && menuItem !== 'Projects'; // All except  
      default:
        return true; // For any other roleId, show all menu items
    }
  };
  
  

  const menu = {
    Home: 1, Items: 2, Banking: 3, Sales: 4, Purchases: 5, Reports: 6, Projects:7, Users:8, Settings: 9, QuickBuy: 10,  Buildcoins: 14, Discounts: 11, RFQRequirements:12, MRS:13, Tickets: 15
  };

  const visibleMenuItemsCount = Object.keys(menu).filter(item => shouldShowMenuItem(item)).length;
  const shouldEnableScroll = visibleMenuItemsCount > 3;
  
  const MainMenu = {
    Home: false, Items: false, Banking: false, Sales: false, Purchases: false, Reports: false, Projects: false, Users: false, Settings: false, QuickBuy: false, Discounts: false , Buildcoins: false , RFQRequirements: false, MRS:false, Tickets: false,
  }
  const ItemsSubMenu = {
  ItemCategories : false, 
  ItemGroups: false,
  Items: false,
  ItemAttributes:false,
  ItemVariants:false,
  Pricelist : false,
  InventoryAdjustMent: false
  }
 
  const SalesSubMenu = {
    Customers : false, 
    Quotes: false,
    SalesOrders: false,
    SOItemsWise: false,
    DeliveryChallans:false,
    Invoices:false,
    PaymentsReceived:false,
    Refunds: false,
    LiveOrderReports: false,
    MaterialRequirements: false,
    RFQRequests: false,
    Orders: false
  }

    const PurchasesSubMenu = {
      Vendors : false,
      PurchaseOrders: false,
      PoItemsWise:false,
      SupplierProducts: false,
      Bills:false,
      Vendorpayments:false
    }

    const ReportsSubMenu = {
      SalesReports: false,
      PurchaseReports: false,
      InventoryReports: false,
      CustomerReports: false,
      VendorReports: false,
      ProjectReports: false,
      ProductPriceReports: false
    }
   
    const SettingsSubMenu = {
      Hubs : false,
      HubProducts: false,
      Templates: false,
      Taxes:false,
      Users: false,
     }

     const QuickBuySubMenu = {
      
     }

     const BuildcoinsSubMenu = {
      BuildcoinRules: false,
      BuildcoinLedgers: false,

     } 

     const DiscountsSubMenu = {
      DiscountRules: false,
      DiscountLedgers: false,
     }

  const handleRemainingMenuClose = (menu) => {
    if (menu === 2) {
      setIsCollapsed(false);
      setSales(false);
      setPurchases(false);
      setReports(false);
      setQuickBuy(false);
      setBuildcoins(false);
      setDiscounts(false);
    } else if (menu === 4) {
      setIsCollapsed(false);
      setItems(false);
      setPurchases(false);
      setReports(false);
      setQuickBuy(false);
      setBuildcoins(false);
      setDiscounts(false);
    } else if (menu === 5) {
      setIsCollapsed(false);
      setItems(false);
      setSales(false);
      setReports(false);
      setQuickBuy(false);
      setBuildcoins(false);
      setDiscounts(false);
    } else if (menu === 6) {
      setIsCollapsed(false);
      setItems(false);
      setSales(false);
      setPurchases(false);
      setQuickBuy(false);
      setBuildcoins(false);
      setDiscounts(false);
    } else if (menu === 10) {
      setIsCollapsed(false);
      setItems(false);
      setSales(false);
      setPurchases(false);
      setReports(false);
      setBuildcoins(false);
      setDiscounts(false);
    } else if (menu === 11) {
      setIsCollapsed(false);
      setItems(false);
      setSales(false);
      setPurchases(false);
      setReports(false);
      setQuickBuy(false);
    } else if (menu === 12) {
      setIsCollapsed(false);
      setItems(false);
      setSales(false);
      setPurchases(false);
      setReports(false);
      setQuickBuy(false);
      setBuildcoins(false);
      setDiscounts(false);
    }
    else {
      setSales(false);
      setItems(false);
      setPurchases(false);
      setReports(false);
      setQuickBuy(false);
      setBuildcoins(false);
      setDiscounts(false);
    }
  };
 
  // const handleProjectsClick = () => {
  //   handleRemainingMenuClose(menu.Projects);
  //   navigate('/admin/app/projects/projectslist', { replace: true });
  //   window.location.href = window.location.href;
  // };
 
  // const handleTemplateClick = () => {
  //   handleMenuClick(menu.Settings, 2);
  //   window.location.href = window.location.href;
  // };

  // useEffect(() => {
  //   if (location.pathname.includes('/admin/app/templates/templatelist')) {
  //     setSettings(true);
  //     MainMenu.Settings = true;
  //     SettingsSubMenu.Templates = true;
  //   }
  // }, [location.pathname]);
  
  const handleMenuClick = (menu, submenu) => {
    console.log(menu, submenu);

  if (isMobile) {
    setIsCollapsed(true);
  }
  

    if(menu === 1){
      navigate('home');
    }else  if (menu === 2) {
      if (submenu === 1) {
        navigate('items/productcategories');
      } else if (submenu === 1.1) {
        navigate('items/newproductcategory');
      }else if(submenu === 2){
        navigate('items/productgroupslist');
      }else if(submenu === 2.1) {
        navigate('items/newproductgroups');
      }
      else if(submenu === 3) {
        navigate('items/itemslist');
      }else if(submenu === 3.1) {
        navigate('items/newitem');
      }
      else if(submenu === 4) {
        navigate('items/productattributes');
      }else if(submenu === 4.1) {
        navigate('items/productattributes');
      }else if(submenu === 4.2) {
        navigate('items/productvariants');
      }
      else if(submenu === 5) {
        navigate('items/viewpricelists');
      }else if(submenu === 5.1) {
        navigate('items/newpricelist');
      }
    }else  if (menu === 4) {  // hear 2 is the sub menus of the Sales
      if (submenu === 2) {
        navigate('sales/customerslist');
      }else if (submenu === 2.1) {
        navigate('sales/newcustomer');
      }else if (submenu === 3) {
        navigate('sales/quotelists');
      }
      else if (submenu === 3.1 ) {
        navigate('sales/newquote');
      }
      else if (submenu === 4) {
        navigate('sales/salesordersitemwise');
      }else if (submenu === 4.1) {
        navigate('sales/newsalesorder');
      }
      else if (submenu === 5) {
        navigate('sales/salesorderslist');
      }
      else if (submenu === 5.1) {
        navigate('sales/newsalesorder');
      }
      else if (submenu === 6) {
        navigate('deliverychallans/deliverychallanslist');
      }else if (submenu === 6.1) {
        navigate('deliverychallans/newdeliverychallans');
      }
      else if (submenu === 7) {
        navigate('sales/vehicleshedulelist');
      }
      else if (submenu === 7.1) {
        navigate('sales/newvehicleschedule');
      }
      else if (submenu === 8) {
        navigate('sales/paymentreceivedlist');
      } else if (submenu === 8.1) {
        navigate('sales/newpaymentreceived');
      }
      else if (submenu === 9) {
        navigate('sales/invoiceslist');
      } else if (submenu === 9.1) {
        navigate('sales/newinvoice');
      }
      else if (submenu === 10) {
        navigate('sales/liveorders');
      }
      else if (submenu === 11) {
        navigate('/admin/app/mr/materialrequirements');
      }
      else if (submenu === 12) {
        navigate('/admin/app/rfq/rfqrequirements');
      }
      else if (submenu === 14) {
        navigate('sales/orders');
      }else if (submenu === 15) {
        navigate('sales/refundlist');
      }else if (submenu === 15.1) {
        navigate('sales/newrefund');
      }
       
    }else  if (menu === 5) {  // hear 2 is the sub menus of the Sales
      if (submenu === 1) {
        navigate('purchases/vendorslist');
      }else if (submenu === 1.1) {
        navigate('purchases/newvendor');
      }
      else if (submenu === 2) {
        navigate('purchases/purchaseorderitemwise');
      }else if (submenu === 2.1) {
        navigate('purchases/newpurchaseorder');
      }
       else if (submenu === 3) {
        navigate('purchases/purchaseorderlist');
      }else if (submenu === 3.1) {
        navigate('purchases/newpurchaseorder');
      }
      else if (submenu === 4) {
        navigate('purchases/SupplierProducts');
      }
      else if (submenu === 5) {
        navigate('bills/billlist');
      }else if (submenu === 5.1) {
        navigate('bills/newbill');
      }
      else if (submenu === 6) {
        navigate('vendorpayments/vendorpaymentlist');
      }else if (submenu === 6.1) {
        navigate('vendorpayments/newvendorpayment');
      }
    }else if (menu === 6) {  // Reports menu
      if (submenu === 1) {
        navigate('reports/liveorders');
      } else if (submenu === 2) {
        navigate('reports/purchasereports');
      } else if (submenu === 3) {
        navigate('reports/inventoryreports');
      } else if (submenu === 4) {
        navigate('reports/customerreports');
      } else if (submenu === 5) {
        navigate('reports/vendorreports');
      } else if (submenu === 6) {
        navigate('reports/projectreports');
      } else if (submenu === 7) {
        navigate('reports/productpricereports');
      }
    }else if (menu === 7){
      if(submenu === 1){
        if (location.pathname.includes('/admin/app/projects/projectslist')) {
          window.dispatchEvent(new CustomEvent('refreshProjectList'));
        } else {  
          navigate('projects/projectslist');
        }
      }else if (submenu === 1.1){
        navigate('projects/newproject')
      }
    }else if (menu === 9){
      if(submenu === 1){
        navigate('settings/hublist');
      }else if (submenu ===1.1){
        navigate('settings/newhub');
      }else if (submenu === 1.2){
        navigate('settings/hub-products');
      } else if (submenu === 2) { 
         if (location.pathname.includes('/admin/app/templates/templatelist')) {
        window.dispatchEvent(new CustomEvent('refreshTemplateList'));
      } else {
        navigate('/admin/app/templates/templatelist');
      }
        navigate('/admin/app/templates/templatelist');
      }else if (submenu ===2.1){
        navigate('/admin/app/templates/template');
      }else if (submenu === 3) {
        navigate('/admin/app/settings/zones');
      }else if (submenu === 4) {
        navigate('/admin/app/settings/usermanagement');
      }
    }else if( menu=== 8){
      if(submenu === 1){
        navigate('users/userslist')
      }else if (submenu === 1.1){
        navigate('users/newuser')
      }
    } else if (menu === 14) {  // Buildcoins menu
      if (submenu === 1) {
        if (location.pathname.includes('/admin/app/rewardrules/rewardruleslist')) {
          window.dispatchEvent(new CustomEvent('refreshRewardRulesList'));
        } else {
          navigate('/admin/app/rewardrules/rewardruleslist');
        }
      } else if (submenu === 1.1) {
        navigate('/admin/app/rewardrules/rewardruleslist');
      } else if (submenu === 2) {
        navigate('rewards/rewardledgerlist');
      } else if (submenu === 2.1) {
        navigate('rewards/newrewardledger');
      }
    } 
    else if (menu === 11) {  // Buildcoins menu
      if (submenu === 1) {
        if (location.pathname.includes('/admin/app/discountrules/discountruleslist')) {
          window.dispatchEvent(new CustomEvent('refreshDiscountRulesList'));
        } else {
          navigate('/admin/app/discountrules/discountruleslist');
        }
      } else if (submenu === 1.1) {
        navigate('/admin/app/discountrules/discountruleslist');
      } 
    }else if (menu === 12) {
      navigate('/admin/app/rfq/rfqrequirements');
    }
    else if (menu === 13) {
      navigate('/admin/app/mr/materialrequirements');
    } else if (menu === 15) {
      navigate('/admin/app/tickets/ticketslist');
    }
    if (!isMobile) {
      setIsCollapsed(false);
    }
  };

  const isCurrentPath = (path) => location.pathname.toLowerCase() === path.toLowerCase();
  
    if(isCurrentPath('/admin/app/home')){
      MainMenu.Home = true
    }
    if(isCurrentPath('/admin/app/sales/orders')){
      MainMenu.Sales = true;
      SalesSubMenu.Orders = true;
    }
    if(isCurrentPath('/admin/app/rfq/rfqrequirements')){
      MainMenu.Sales = true;
      SalesSubMenu.RFQRequests = true;
    }

    if(isCurrentPath('/admin/app/mr/materialrequirements')){
      MainMenu.Sales = true;
      SalesSubMenu.MaterialRequirements = true;
    }
     if(isCurrentPath('/admin/app/items/productcategories')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemCategories=true
     }
     if(isCurrentPath('/admin/app/items/newproductcategory')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemCategories=true
     }
     if(isCurrentPath('/admin/app/items/productattributes')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemAttributes=true
     }
     if(isCurrentPath('/admin/app/items/productvariants')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemVariants=true
     }
     if(isCurrentPath('/admin/app/items/productcategorydetails')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemCategories=true
     }
     if(isCurrentPath('/admin/app/items/editproductcategory')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemCategories=true
      }
     if(isCurrentPath('/admin/app/items/productgroupslist')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemGroups=true
     }
     if(isCurrentPath('/admin/app/items/newproductgroups')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemGroups=true
     }
     if(isCurrentPath('/admin/app/items/productgroupdetails')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemGroups=true   
     }
     if(isCurrentPath('/admin/app/items/editproductgroup')){
      MainMenu.Items = true;
      ItemsSubMenu.ItemGroups=true
      }
     if(isCurrentPath('/admin/app/items/itemslist')){
      MainMenu.Items = true;
      ItemsSubMenu.Items=true   
     }
     if(isCurrentPath('/admin/app/items/newitem')){
      MainMenu.Items = true;
      ItemsSubMenu.Items=true   
     }
     if(isCurrentPath('/admin/app/items/itemdetails')){
      MainMenu.Items = true;
      ItemsSubMenu.Items=true   
     }
      if(isCurrentPath('/admin/app/items/edititems')){
      MainMenu.Items = true;
      ItemsSubMenu.Items=true
      }
     if(isCurrentPath('/admin/app/items/viewpricelists')){
      MainMenu.Items = true;
      ItemsSubMenu.Pricelist=true
     }
     if(isCurrentPath('/admin/app/items/newpricelist')){
      MainMenu.Items = true;
      ItemsSubMenu.Pricelist=true
     }
     if(isCurrentPath('/admin/app/items/EditPriceList')){
      MainMenu.Items = true;
      ItemsSubMenu.Pricelist=true   
     }
     if(isCurrentPath('/admin/app/sales/customerslist')){
      MainMenu.Sales = true;
      SalesSubMenu.Customers=true
     }
     if(isCurrentPath('/admin/app/sales/customerdetails')){
      MainMenu.Sales = true;
      SalesSubMenu.Customers=true
     }
     if(isCurrentPath('/admin/app/sales/newcustomer')){
      MainMenu.Sales = true;
      SalesSubMenu.Customers=true
     }
     if(isCurrentPath('/admin/app/sales/editcustomer')){
      MainMenu.Sales = true;
      SalesSubMenu.Customers=true
     }
     if(isCurrentPath('/admin/app/sales/newquote')){
      MainMenu.Sales = true;
      SalesSubMenu.Quotes=true
     }
     if(isCurrentPath('/admin/app/sales/quotelists')){
      MainMenu.Sales = true;
      SalesSubMenu.Quotes=true
     }
     if(isCurrentPath('/admin/app/sales/editquote')){
      MainMenu.Sales = true;
      SalesSubMenu.Quotes=true
     }
     if(isCurrentPath('/admin/app/sales/quotedetails')){
      MainMenu.Sales = true;
      SalesSubMenu.Quotes=true
     }
     if(isCurrentPath('/admin/app/sales/newsalesorder')){
      MainMenu.Sales = true;
      SalesSubMenu.SalesOrders=true
     }
     if(isCurrentPath('/admin/app/sales/salesorderslist')){
      MainMenu.Sales = true;
      SalesSubMenu.SalesOrders=true
     }
      if(isCurrentPath('/admin/app/sales/salesorderdetails')){
      MainMenu.Sales = true;
      SalesSubMenu.SalesOrders=true
      }
      if(isCurrentPath('/admin/app/sales/editsalesorder')){
      MainMenu.Sales = true;
      SalesSubMenu.SalesOrders=true
      }
     if(isCurrentPath('/admin/app/sales/salesordersitemwise')){
      MainMenu.Sales = true;
      SalesSubMenu.SOItemsWise=true
     }
     if(isCurrentPath('/admin/app/sales/invoicedetails')){
      MainMenu.Sales = true;
      SalesSubMenu.Invoices = true
     }
     if(isCurrentPath('/admin/app/sales/invoiceslist')){
      MainMenu.Sales = true;
      SalesSubMenu.Invoices = true
     }
     if(isCurrentPath('/admin/app/sales/newinvoice')){
      MainMenu.Sales = true;
      SalesSubMenu.Invoices = true
     }
     if(isCurrentPath('/admin/app/sales/editinvoice')){
      MainMenu.Sales = true;
      SalesSubMenu.Invoices = true
     }
     if(isCurrentPath('/admin/app/sales/paymentreceiveddetails')){
      MainMenu.Sales = true;
      SalesSubMenu.PaymentsReceived = true
     }
     if(isCurrentPath('/admin/app/sales/paymentreceivedlist')){
      MainMenu.Sales = true;
      SalesSubMenu.PaymentsReceived = true
     }
     if(isCurrentPath('/admin/app/sales/newpaymentreceived')){
      MainMenu.Sales = true;
      SalesSubMenu.PaymentsReceived = true
     }
     if(isCurrentPath('/admin/app/sales/editpaymentreceived')){
      MainMenu.Sales = true;
      SalesSubMenu.PaymentsReceived = true
     }
     if(isCurrentPath('/admin/app/sales/refundlist')){
      MainMenu.Sales = true;
      SalesSubMenu.Refunds = true
     }
      if(isCurrentPath('/admin/app/sales/refunddetails')){
      MainMenu.Sales = true;
      SalesSubMenu.Refunds = true
     }
     if(isCurrentPath('/admin/app/sales/newrefund')){
      MainMenu.Sales = true;
      SalesSubMenu.Refunds = true
     }
     if(isCurrentPath('/admin/app/sales/editrefund')){
      MainMenu.Sales = true;
      SalesSubMenu.Refunds = true
     }

     if(isCurrentPath('/admin/app/sales/newvehicleschedule')){
      MainMenu.Sales = true;
      SalesSubMenu.VehicleSchedule=true
     }
     if(isCurrentPath('/admin/app/sales/vehicleshedulelist')){
      MainMenu.Sales = true;
      SalesSubMenu.VehicleSchedule=true
     }
     if(isCurrentPath('/admin/app/sales/vehicleschedulingdetails')){
      MainMenu.Sales = true;
      SalesSubMenu.VehicleSchedule=true
     }
     if(isCurrentPath('/admin/app/deliverychallans/deliverychallanslist')){
      MainMenu.Sales = true;
      SalesSubMenu.DeliveryChallans=true
     }
     if(isCurrentPath('/admin/app/deliverychallans/newdeliverychallans')){
      MainMenu.Sales = true;
      SalesSubMenu.DeliveryChallans=true
     }
     if(isCurrentPath('/admin/app/deliverychallans/deliverychallandetails')){
      MainMenu.Sales = true;
      SalesSubMenu.DeliveryChallans=true
     }
     if(isCurrentPath('/admin/app/purchases/vendorslist')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Vendors = true
     }
     if(isCurrentPath('/admin/app/purchases/newvendor')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Vendors = true
     }
      if(isCurrentPath('/admin/app/purchases/vendordetails')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Vendors = true
     }
     if(isCurrentPath('/admin/app/purchases/editvendor')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Vendors = true
     }
     if(isCurrentPath('/admin/app/purchases/purchaseorderitemwise')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.PoItemsWise = true
     }
     if(isCurrentPath('/admin/app/purchases/purchaseorderlist')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.PurchaseOrders = true
     }
     if(isCurrentPath('/admin/app/purchases/newpurchaseorder')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.PurchaseOrders = true
     }
      if(isCurrentPath('/admin/app/purchases/purchaseorderdetails')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.PurchaseOrders = true
     }
      if(isCurrentPath('/admin/app/purchases/editpurchaseorder')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.PurchaseOrders = true
     }
     if(isCurrentPath('/admin/app/purchases/supplierproducts')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.SupplierProducts = true
     }
      if(isCurrentPath('/admin/app/bills/billlist')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Bills = true
     }
      if(isCurrentPath('/admin/app/bills/newbill')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Bills = true
     }
     if(isCurrentPath('/admin/app/bills/billdetails')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Bills = true
     }
     if(isCurrentPath('/admin/app/editbill')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Bills = true
     }
      if(isCurrentPath('/admin/app/vendorpayments/vendorpaymentlist')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Vendorpayments = true
     }
      if(isCurrentPath('/admin/app/vendorpayments/newvendorpayment')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Vendorpayments = true
     }
      if(isCurrentPath('/admin/app/vendorpayments/vendorpaymentdetails')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Vendorpayments = true
     }
      if(isCurrentPath('/admin/app/vendorpayments/editvendorpayment')){
      MainMenu.Purchases = true;
      PurchasesSubMenu.Vendorpayments = true
     }
     
     // Reports path checks
     if(isCurrentPath('/admin/app/reports/salesreports')){
      MainMenu.Reports = true;
      ReportsSubMenu.SalesReports = true
     }
     if(isCurrentPath('/admin/app/reports/purchasereports')){
      MainMenu.Reports = true;
      ReportsSubMenu.PurchaseReports = true
     }
     if(isCurrentPath('/admin/app/reports/inventoryreports')){
      MainMenu.Reports = true;
      ReportsSubMenu.InventoryReports = true
     }
     if(isCurrentPath('/admin/app/reports/customerreports')){
      MainMenu.Reports = true;
      ReportsSubMenu.CustomerReports = true
     }
     if(isCurrentPath('/admin/app/reports/vendorreports')){
      MainMenu.Reports = true;
      ReportsSubMenu.VendorReports = true
     }
     if(isCurrentPath('/admin/app/reports/projectreports')){
      MainMenu.Reports = true;
      ReportsSubMenu.ProjectReports = true
     }
     if(isCurrentPath('/admin/app/reports/productpricereports')){
      MainMenu.Reports = true;
      ReportsSubMenu.ProjectReports = true
     }
    
     
     if(isCurrentPath('/admin/app/projects/projectslist')){
      MainMenu.Projects = true; 
     }
     if(isCurrentPath('/admin/app/projects/newproject')){
      MainMenu.Projects = true; 
     }
     
     if(isCurrentPath('/admin/app/projects/projectdetails')){
      MainMenu.Projects = true; 
     }
     if(isCurrentPath('/admin/app/projects/editproject')){
      MainMenu.Projects = true; 
     }
     if(isCurrentPath('/admin/app/projects/blockdetails')){
      MainMenu.Projects = true; 
     }
     if(isCurrentPath('/admin/app/projects/measurements')){
      MainMenu.Projects = true; 
     }
     if(isCurrentPath('/admin/app/settings/zones')){
      MainMenu.Settings = true;
      SettingsSubMenu.Zones = true
     }
     if(isCurrentPath('/admin/app/settings/usermanagement')){
      MainMenu.Settings = true;
      SettingsSubMenu.Users = true
     }
     if(isCurrentPath('/admin/app/settings/newhub')){
      MainMenu.Settings = true;
      SettingsSubMenu.Hubs = true
     }
     if(isCurrentPath('/admin/app/settings/hublist')){
      MainMenu.Settings = true;
      SettingsSubMenu.Hubs = true
    }    
    if(isCurrentPath('/admin/app/settings/hubdetails')){
      MainMenu.Settings = true;
      SettingsSubMenu.Hubs = true
    }
    if(isCurrentPath('/admin/app/settings/edithub')){
      MainMenu.Settings = true;
      SettingsSubMenu.Hubs = true
    }
    if(isCurrentPath('/admin/app/settings/hub-products')){
      MainMenu.Settings = true;
      SettingsSubMenu.HubProducts = true
    }
    if(isCurrentPath('/admin/app/templates/template')){
      MainMenu.Settings = true;  
      SettingsSubMenu.Templates = true
    }
    if(isCurrentPath('/admin/app/templates/templatelist')){ 
      MainMenu.Settings = true;  
      SettingsSubMenu.Templates = true
    }
    
     if(isCurrentPath('/admin/app/settings/taxlist')){
      MainMenu.Settings = true;
      SettingsSubMenu.Taxes = true
     }
     if(isCurrentPath('/admin/app/settings/newtax')){
      MainMenu.Settings = true;
      SettingsSubMenu.Taxes = true
     }
     
    // QuickBuy path checks (moved items now set under Purchases/Sales)
    // if(isCurrentPath('/admin/app/quickbuy/SupplierProducts')){
    //  MainMenu.Purchases = true;
    //  PurchasesSubMenu.SupplierProducts = true
    // }
    if(isCurrentPath('/admin/app/quickbuy/liveorders')){
     MainMenu.Sales = true;
     SalesSubMenu.LiveOrderReports = true
    }
     
     
     // Buildcoins path checks
      if(isCurrentPath('/admin/app/rewardrules/newrewardrule')){
      MainMenu.Buildcoins = true;  
      BuildcoinsSubMenu.BuildcoinRules = true
     }
     if(isCurrentPath('/admin/app/rewardrules/editrewardrule')){
      MainMenu.Buildcoins = true;  
      BuildcoinsSubMenu.BuildcoinRules = true
     }
     if(isCurrentPath('/admin/app/rewardrules/rewardruleslist')){
      MainMenu.Buildcoins = true;  
      BuildcoinsSubMenu.BuildcoinRules = true
     }
     if(isCurrentPath('/admin/app/rewards/rewardledgerlist')){
      MainMenu.Buildcoins = true;  
      BuildcoinsSubMenu.BuildcoinLedgers = true
     }
     if(isCurrentPath('/admin/app/rewards/newrewardledger')){
      MainMenu.Buildcoins = true;  
      BuildcoinsSubMenu.BuildcoinLedgers = true
     }
     if(isCurrentPath('/admin/app/rewards/rewardledgerdetails')){
      MainMenu.Buildcoins = true;  
      BuildcoinsSubMenu.BuildcoinLedgers = true
     } 

    // Discounts path checks
    if(isCurrentPath('/admin/app/discountrules/discountruleslist')){
      MainMenu.Discounts = true;  
      DiscountsSubMenu.DiscountRules = true
     }
     if(isCurrentPath('/admin/app/discountrules/discountrulesengine')){
      MainMenu.Discounts = true;  
      DiscountsSubMenu.DiscountRules = true
     }
    
     return (
      <div className={`flex flex-col text-[0.8125rem] bg-[#f7f7fe] border-r font-normal h-full ${isCollapsed ? 'w-[3.125rem]' : 'w-[12.5rem]'}`}>
      <div className={`flex flex-col flex-1 w-full rounded-md ${shouldEnableScroll ? 'overflow-y-auto' : ''} ${isCollapsed ? '' : ''}`}>
        <div className={`${shouldEnableScroll ? 'max-h-[calc(100vh-2rem)]' : ''} flex-grow`}>
          <ul className="flex flex-col space-y-3 px-2 list-none h-full mt-4 text-[#181C2E]">
          {shouldShowMenuItem('Home') && (

            <li onClick={() => {handleRemainingMenuClose(menu.Home); handleMenuClick(menu.Home); handleMenuClick(menu.Home);
          }}
              className={`flex flex-row space-x-3 items-center py-2  rounded-l-md cursor-pointer ${MainMenu.Home ? 'bg-[#f7525A] text-white' : 'hover:bg-[#EDEDF7]'}`}>
              <FontAwesomeIcon icon={faHome} className={`ml-2 mr-2 ${MainMenu.Home ? 'text-white ' : ''}`} />
              {!isCollapsed && <span>Home</span>}
            </li>
                      )}
          {shouldShowMenuItem('Items') && (            
            <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${MainMenu.Items ? ' bg-[#EDEDF7] text-[#f7525A]' : ''}`}
              onClick={() => { setItems(!Items); handleRemainingMenuClose(menu.Items); handleMenuClick(menu.Items); handleMenuClick(menu.Items); }}>
              <FontAwesomeIcon icon={faBagShopping} className={`ml-2 mr-2 ${MainMenu.Items ? 'text-[#f7525A]' : ''}`} />
              {!isCollapsed && <span>Items</span>}
              {!isCollapsed && (
                <>
                  {Items ? (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  ) : (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretRight} />
                    </div>
                  )}
                </>
              )}
            </li>
          )}
            {Items && (
              !isCollapsed && (
                <ul className="flex flex-col space-y-2 justify-center items-center cursor-pointer">
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ItemsSubMenu.ItemCategories ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Items, 1)}>
                    <span className="ml-6">Item Categories</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${ItemsSubMenu.ItemCategories ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Items, 1.1);
                        }} />
                    </div>
                  </li>
                  
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ItemsSubMenu.ItemGroups ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                  onClick={() => handleMenuClick(menu.Items, 2)}>
                    <span className='ml-6'>Item Groups</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${ItemsSubMenu.ItemGroups ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Items, 2.1);
                        }} />
                    </div>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ItemsSubMenu.Items ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                  onClick={() => handleMenuClick(menu.Items, 3)}>
                    <span className='ml-6'>Items</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${ItemsSubMenu.Items ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Items, 3.1);
                        }} />
                    </div>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ItemsSubMenu.ItemAttributes ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Items, 4)}>
                    <span className='ml-6'>Item Attributes</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${ItemsSubMenu.ItemAttributes ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Items, 4.1);
                        }} />
                    </div>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ItemsSubMenu.ItemVariants ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Items, 4.2)}>
                    <span className='ml-6'>Item Variants</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${ItemsSubMenu.ItemVariants ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Items, 4.2);
                        }} />
                    </div>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ItemsSubMenu.Pricelist ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                  onClick={() => handleMenuClick(menu.Items, 5)}>
                    <span className='ml-6'>Price list</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${ItemsSubMenu.Pricelist ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Items, 5.1);
                        }} />
                    </div>
                  </li>
                  {/* <li className="group flex flex-row justify-between items-center p-2 w-full max-w-md hover:bg-[#EDEDF7] hover:rounded-l-md cursor-pointer">
                    <span className='ml-6'>Inventory Adjustment</span>
                    <div className="w-5">
                      <FontAwesomeIcon icon={faPlusCircle} className="hidden group-hover:inline-block" />
                    </div>
                  </li> */}
                </ul>
              )
            )}
           {/*  <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] hover:rounded-l-md cursor-pointer ${isCurrentPath('bb/admin/App/banking') ? 'bg-blue-500 text-white' : ''}`}
              onClick={() => handleRemainingMenuClose(menu.Banking)}>
              <FontAwesomeIcon icon={faBank} className={`ml-2 mr-2 ${isCurrentPath('bb/admin/App/banking') ? 'text-white' : ''}`} />
              {!isCollapsed && <span>Banking</span>}
            </li> */}
            {shouldShowMenuItem('Sales') && (
            <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${MainMenu.Sales ? ' bg-[#EDEDF7] text-[#f7525A]' : ''}`}
              onClick={() => { setSales(!Sales); handleRemainingMenuClose(menu.Sales);handleMenuClick(menu.Sales); }}>
              <FontAwesomeIcon icon={faCartShopping}  className={`ml-2 mr-2 ${MainMenu.Sales ? 'text-[#f7525A]' : ''}`} />
              {!isCollapsed && <span>Sales</span>}
              {!isCollapsed && (
                <>
                  {Sales ? (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  ) : (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretRight} />
                    </div>
                  )}
                </>
              )}
            </li>
            )}
            {Sales && (
              !isCollapsed && (
                <ul className="flex flex-col space-y-2 justify-center items-center cursor-pointer">
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.Customers ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                  onClick={() => handleMenuClick(menu.Sales, 2)}
                 >
                    <span className='ml-7'>Customers</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SalesSubMenu.Customers ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Sales, 2.1);
                        }} />
                    </div>
                  </li>

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.MaterialRequirements ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 11)}>
                    <span className='ml-7'>Material Requirements</span>
                  </li>

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.RFQRequests ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 12)}>
                    <span className='ml-7'>RFQs</span>
                  </li>

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.Quotes ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 3)}>
                    <span className='ml-7'>Quotes</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SalesSubMenu.Quotes ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Sales, 3.1);
                        }} />
                    </div>
                  </li>

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.Orders ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 14)}>
                    <span className='ml-7'>Orders</span>
                  </li>

                  {/*<li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.LiveOrderReports ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 10)}>
                    <span className='ml-7'>Live Orders</span>
                  </li> */}

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.SOItemsWise ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 4)}>
                    <span className='ml-7'>SO Itemwise</span>
                  </li>

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.SalesOrders ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 5)}>
                    <span className='ml-7'>Sales Orders</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SalesSubMenu.SalesOrders ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Sales, 5.1);
                        }} />
                    </div>
                  </li>
                
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.DeliveryChallans ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 6)}>
                    <span className='ml-7'>Delivery Challans</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SalesSubMenu.DeliveryChallans ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Sales, 6.1);
                        }} />
                    </div>
                  </li>   

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SalesSubMenu.VehicleSchedule ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 7)}>
                    <span className='ml-7'>Vehicle Schedule</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SalesSubMenu.VehicleSchedule ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Sales, 7.1);
                        }} />
                    </div>
                  </li>   

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md whitespace-nowrap rounded-l-md cursor-pointer ${SalesSubMenu.Invoices ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 9)}>
                    <span className='ml-7'>Invoices</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SalesSubMenu.Invoices ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Sales, 9.1);
                        }} />
                    </div>
                  </li>   

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md whitespace-nowrap rounded-l-md cursor-pointer ${SalesSubMenu.PaymentsReceived ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 8)}>
                    <span className='ml-7'>Payments</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SalesSubMenu.PaymentsReceived ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Sales, 8.1);
                        }} />
                    </div>
                  </li>   

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md whitespace-nowrap rounded-l-md cursor-pointer ${SalesSubMenu.Refunds ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                   onClick={() => handleMenuClick(menu.Sales, 15)}>
                    <span className='ml-7'>Refunds</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SalesSubMenu.Refunds ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Sales, 15.1);
                        }} />
                    </div>
                  </li> 

                   </ul>
              )
            )}
                       {shouldShowMenuItem('Purchases') && (
            <li onClick={() => { setPurchases(!Purchases); handleRemainingMenuClose(menu.Purchases);
              handleMenuClick(menu.Purchases);
            }}
              className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${MainMenu.Purchases ? ' bg-[#EDEDF7] text-[#f7525A]' : ''}`}>
              <FontAwesomeIcon icon={faBasketShopping} className={`ml-2 mr-2 ${MainMenu.Purchases ? 'text-[#f7525A]' : ''}`} />
              {!isCollapsed && <span>Purchases</span>}
              {!isCollapsed && (
                <>
                  {Purchases ? (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  ) : (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretRight} />
                    </div>
                  )}
                </>
              )}
            </li>
            )}
            {Purchases && (
              !isCollapsed && (
                <ul className="flex flex-col space-y-2 justify-center items-center cursor-pointer">
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${PurchasesSubMenu.Vendors ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Purchases, 1)}>
                    <span className='ml-7'>Vendors</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${PurchasesSubMenu.Vendors  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Purchases, 1.1);
                        }} />
                    </div>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${PurchasesSubMenu.SupplierProducts ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Purchases, 4)}>
                    <span className='ml-7'>Supplier Products</span>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${PurchasesSubMenu.PoItemsWise ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Purchases, 2)}>
                    <span className='ml-7'>PO Itemwise</span>
                    {/* <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${PurchasesSubMenu.PoItemsWise  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Purchases, 2.1);
                        }} />
                    </div> */}
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${PurchasesSubMenu.PurchaseOrders ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Purchases, 3)}>
                    <span className='ml-7'>Purchase Orders</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${PurchasesSubMenu.PurchaseOrders  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Purchases, 3.1);
                        }} />
                    </div>
                  </li>
                     <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${PurchasesSubMenu.Bills ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Purchases, 5)}>
                    <span className='ml-7'>Bills</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${PurchasesSubMenu.Bills  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Purchases, 5.1);
                        }} />
                    </div>
                  </li>
                    <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${PurchasesSubMenu.Vendorpayments ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Purchases, 6)}>
                    <span className='ml-7'>Vendor Payments</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${PurchasesSubMenu.Vendorpayments  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Purchases, 6.1);
                        }} />
                    </div>
                  </li>
                 
                </ul>
              )
            )}
            
            {shouldShowMenuItem('Projects') && (
  <li onClick={() => handleMenuClick(menu.Projects, 1)}  
  className={`group flex flex-row space-x-3 items-center py-2 w-full max-w-md  rounded-l-md cursor-pointer ${MainMenu.Projects ?'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}>
              <FontAwesomeIcon icon={faDashboard} className={`ml-2 mr-2 ${isCurrentPath('bb/admin/App/reports') ? 'text-white' : ''}`} />
              {!isCollapsed && <span className=''>Projects</span>
              }
              <div className="w-5 " onClick={(e) => e.stopPropagation(menu.Projects )}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${MainMenu.Projects  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Projects, 1.1);
                        }} />
                    </div>
              
            </li>
                         )}

              
            {shouldShowMenuItem('Tickets') && (
              <li
                onClick={() => {
                  handleRemainingMenuClose(menu.Tickets);
                  handleMenuClick(menu.Tickets);
                }}
                className={`flex flex-row space-x-3 items-center py-2 w-full max-w-md rounded-l-md cursor-pointer ${
                  location.pathname.toLowerCase().startsWith('/admin/app/tickets')
                    ? 'bg-[#f7525a] text-white'
                    : 'hover:bg-[#EDEDF7]'
                }`}
              >
                <FontAwesomeIcon
                  icon={faRectangleList}
                  className={`ml-2 mr-2 ${
                    location.pathname.toLowerCase().startsWith('/admin/app/tickets')
                      ? 'text-white'
                      : ''
                  }`}
                />

                {!isCollapsed && <span>Tickets</span>}

                <div className="ml-auto mr-2 flex items-center justify-center">
                  <span
                    title={`${liveTicketsCount} active tickets`}
                    className={`min-w-5 rounded-full px-1.5 py-0.5 text-center text-[10px] font-semibold ${
                      location.pathname.toLowerCase().startsWith('/admin/app/tickets')
                        ? 'bg-white text-[#f7525a]'
                        : 'bg-[#f7525a] text-white'
                    }`}
                  >
                    {liveTicketsCount > 99 ? '99+' : liveTicketsCount}
                  </span>
                </div>
              </li>
            )}
           

             {shouldShowMenuItem('Buildcoins') && (
            <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${MainMenu.Buildcoins ? ' bg-[#EDEDF7] text-[#f7525A]' : ''}`}
              onClick={() => { setBuildcoins(!Buildcoins); handleRemainingMenuClose(menu.Buildcoins); handleMenuClick(menu.Buildcoins, 1); }}>
              <FontAwesomeIcon icon={faCoins} className={`ml-2 mr-2 ${MainMenu.Buildcoins ? 'text-[#f7525A]' : ''}`} />
              {!isCollapsed && <span>Brickpoints</span>}
{/*               {!isCollapsed && (
                <>
                  {Buildcoins ? (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  ) : (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretRight} />
                    </div>
                  )}
                </>
              )} */}
            </li>
            )}

            {Buildcoins && (
              !isCollapsed && (
                <ul className="flex flex-col space-y-2 justify-center items-center cursor-pointer">
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${BuildcoinsSubMenu.BuildcoinRules ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Buildcoins, 1)}>
                    <span className='ml-7'>Buildpoint Rules</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${BuildcoinsSubMenu.BuildcoinRules ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Buildcoins, 1.1);
                        }} />
                    </div>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${BuildcoinsSubMenu.BuildcoinLedgers ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Buildcoins, 2)}>
                    <span className='ml-7'>Brickpoint Ledgers</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${BuildcoinsSubMenu.BuildcoinLedgers ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Buildcoins, 2.1);
                        }} />
                    </div>
                  </li>
                </ul>
              )
            )} 

            {shouldShowMenuItem('Discounts') && (
            <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${MainMenu.Discounts ? ' bg-[#EDEDF7] text-[#f7525A]' : ''}`}
              onClick={() => { setDiscounts(!Discounts); handleRemainingMenuClose(menu.Discounts); handleMenuClick(menu.Discounts); }}>
              <FontAwesomeIcon icon={faTag} className={`ml-2 mr-2 ${MainMenu.Discounts ? 'text-[#f7525A]' : ''}`} />
              {!isCollapsed && <span>Offers</span>}
              {!isCollapsed && (
                <>
                  {Discounts ? (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  ) : (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretRight} />
                    </div>
                  )}
                </>
              )}
            </li>
            )}

            {Discounts && (
              !isCollapsed && (
                <ul className="flex flex-col space-y-2 justify-center items-center cursor-pointer">
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${DiscountsSubMenu.DiscountRules ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Discounts, 1)}>
                    <span className='ml-7'>Offer Rules</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${DiscountsSubMenu.DiscountRules ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Discounts, 1.1);
                        }} />
                    </div>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${DiscountsSubMenu.BuildcoinLedgers ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Discounts, 2)}>
                    <span className='ml-7'>Offer Ledgers</span>
{/*                     <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${DiscountsSubMenu.BuildcoinLedgers ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Discounts, 2.1);
                        }} />
                    </div> */}
                  </li>
                </ul>
              )
            )}

            {shouldShowMenuItem('Reports') && (
            <li className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${MainMenu.Reports ? ' bg-[#EDEDF7] text-[#f7525A]' : ''}`}
              onClick={() => { setReports(!Reports); handleRemainingMenuClose(menu.Reports); handleMenuClick(menu.Reports); }}>
              <FontAwesomeIcon icon={faRectangleList} className={`ml-2 mr-2 ${MainMenu.Reports ? 'text-[#f7525A]' : ''}`} />
              {!isCollapsed && <span>Reports</span>}
              {!isCollapsed && (
                <>
                  {Reports ? (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  ) : (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretRight} />
                    </div>
                  )}
                </>
              )}
            </li>
            )}
            {Reports && (
              !isCollapsed && (
                <ul className="flex flex-col space-y-2 justify-center items-center cursor-pointer">
{/*                   <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ReportsSubMenu.SalesReports ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Reports, 1)}>
                    <span className='ml-7'>Sales Order Reports</span>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ReportsSubMenu.PurchaseReports ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Reports, 2)}>
                    <span className='ml-7'>Purchase Reports</span>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ReportsSubMenu.InventoryReports ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Reports, 3)}>
                    <span className='ml-7'>Inventory Reports</span>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ReportsSubMenu.CustomerReports ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Reports, 4)}>
                    <span className='ml-7'>Customer Reports</span>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ReportsSubMenu.VendorReports ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Reports, 5)}>
                    <span className='ml-7'>Vendor Reports</span>
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ReportsSubMenu.ProjectReports ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Reports, 6)}>
                    <span className='ml-7'>Project Reports</span>
                  </li> */}
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${ReportsSubMenu.ProductPriceReports ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Reports, 7)}>
                    <span className='ml-7'>Product Price Reports</span>
                  </li>
                </ul>
              )
            )}


             

         
            
                         {shouldShowMenuItem('Settings') && (
              <li onClick={() => { setSettings(!Settings); handleRemainingMenuClose(menu.Settings); }}
              className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] rounded-l-md cursor-pointer ${MainMenu.Settings ? ' bg-[#EDEDF7] text-[#f7525A]' : ''}`}>
              <FontAwesomeIcon icon={faGear} className={`ml-2 mr-2 ${MainMenu.Settings ? 'text-[#f7525A]' : ''}`} />
              {!isCollapsed && <span>Settings</span>}
              {!isCollapsed && (
                <>
                  {Settings ? (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretDown} />
                    </div>
                  ) : (
                    <div className='w-full flex justify-end px-2'>
                      <FontAwesomeIcon icon={faCaretRight} />
                    </div>
                  )}
                </>
              )}
            </li>
             )}


             
            {Settings && (
              !isCollapsed && (
                <ul className="flex flex-col space-y-2 justify-center items-center cursor-pointer">
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SettingsSubMenu.Zones ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Settings, 3)}>
                    <span className='ml-7'>Zones</span>
{/*                     <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SettingsSubMenu.Zones  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Settings, 3);
                        }} />
                    </div> */}
                  </li>
                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SettingsSubMenu.Hubs ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Settings, 1)}>
                    <span className='ml-7'>Hubs</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SettingsSubMenu.Hubs  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Settings, 1.1);
                        }} />
                    </div>
                  </li>

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SettingsSubMenu.HubProducts ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Settings, 1.2)}>
                    <span className='ml-7'>Assign Products to Hubs</span>
                  </li>

                  <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md rounded-l-md cursor-pointer ${SettingsSubMenu.Templates ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
    onClick={() => handleMenuClick(menu.Settings, 2)}>  
        <span className='ml-7'>Templates</span>
        <div className="w-5" onClick={(e) => e.stopPropagation()}>
          <FontAwesomeIcon icon={faPlusCircle} className={`group-hover:inline-block ${SettingsSubMenu.Templates ? 'text-white block' : 'hidden'}`}
            onClick={(e) => {
              e.stopPropagation();
              handleMenuClick(menu.Settings, 2.1);
            }} />
        </div>
      </li>
                        <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md rounded-l-md cursor-pointer ${SettingsSubMenu.Users ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
    onClick={() => handleMenuClick(menu.Settings, 4)}>  
        <span className='ml-7'>User Management</span>
      </li>
{/*                   <li className={`group flex flex-row justify-between items-center p-2 w-full max-w-md  rounded-l-md cursor-pointer ${SettingsSubMenu.Taxes ? 'bg-[#f7525a] text-white' : 'hover:bg-[#EDEDF7]'}`}
                    onClick={() => handleMenuClick(menu.Settings, 1)}>
                    <span className='ml-7'>Taxes</span>
                    <div className="w-5" onClick={(e) => e.stopPropagation()}>
                      <FontAwesomeIcon icon={faPlusCircle} className={` group-hover:inline-block ${SettingsSubMenu.Taxes  ? 'text-white block' : 'hidden'}`}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent the click event from bubbling up to the li
                          handleMenuClick(menu.Settings, 1.1);
                        }} />
                    </div>
                  </li> */}

                  </ul>
              )
            )}
                        

                         

            {/* <li onClick={() => handleRemainingMenuClose(menu.Accountant)}
              className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] hover:rounded-l-md cursor-pointer ${isCurrentPath('bb/admin/App/accountant') ? 'bg-blue-500 text-white' : ''}`}>
              <FontAwesomeIcon icon={faUserPlus} className={`ml-2 mr-2 ${isCurrentPath('bb/admin/App/accountant') ? 'text-white' : ''}`} />
              {!isCollapsed && <span>Accountant</span>}
            </li> */}
           {/*  <li onClick={() => handleRemainingMenuClose(menu.Documents)}
              className={`flex flex-row space-x-3 items-center py-2 hover:bg-[#EDEDF7] hover:rounded-l-md cursor-pointer ${isCurrentPath('bb/admin/App/documents') ? 'bg-blue-500 text-white' : ''}`}>
              <FontAwesomeIcon icon={faFolder} className={`ml-2 mr-2 ${isCurrentPath('bb/admin/App/documents') ? 'text-white' : ''}`} />
              {!isCollapsed && <span>Documents</span>}
            </li> */}
          </ul>
        </div>
      </div>
      <div className="flex justify-center h-[2rem] bg-[#ededf7] items-center cursor-pointer" onClick={toggleCollapse}>
        {isCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
      </div>
      
    </div>
  
     );
    };


export default Sidebar;